







import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class TableHeaderButtons extends Vue {
  @Prop() updateSearchPanel: () => void;

  print() {
    window.print();
  }
}
